import axios from 'axios';
import Vue from 'vue'

export default {

    getPrices (page, pageSize,filter) {
        return axios.get('/api/prices/list', { params: { page: page, pageSize: pageSize,filter:filter} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    exportPriceCSV(priceId){
        axios({
            url:'/api/prices/downloadCSV/'+priceId,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
            const blob = new Blob(
                [response.data], { type: 'text/csv;charset=utf-8;' })
                const aEle = document.createElement('a');     // Create a label
                const href = window.URL.createObjectURL(blob);       // Create downloaded link
                aEle.href = href;
                aEle.download = response.headers["filename"];  // File name after download
                document.body.appendChild(aEle);
                aEle.click();     // Click to download
                document.body.removeChild(aEle); // Download complete remove element
                window.URL.revokeObjectURL(href) // Release blob object
          });
    },

    exportCSV(priceId){
        return axios({
            url:'/api/prices/downloadCSV/'+priceId,
            method: 'GET',
          }).then(() => {
            
            return this.exportPriceCSV(priceId);
                
        }).catch(error => {Vue.prototype.$snotify.error(error);});
        },

}

